import React from "react";
import TextEditor from "@icarius-common/textEditor";
import { getLocalizedString } from "@icarius-localization/strings";
import { Typography } from "@material-ui/core";
import { getFullDateDayName } from "@icarius-utils/date";
import Container from "../../../../container";
import StatusChip from "../../mainContent/statusChip";

const GradesHistoryContent = ({ data }) => {

    if (!data?.length) return null;

    return (
        <>
            {
                data.map((grade) => {
                    return (
                        <Container
                            key={grade.attempt}
                            title={`${getLocalizedString("grade")} - ${getLocalizedString("attempt")} ${grade.attempt}:`}
                            style={{ width: "100%" }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 5,
                                }}
                            >
                                <StatusChip
                                    passed={grade.passed}
                                    showIcon
                                />
                                <Typography style={{ marginTop: 5 }}>
                                    <span style={{ textDecoration: "underline" }}>{getLocalizedString("score")}:</span> {grade.score}
                                </Typography>
                                <Typography variant="caption">
                                    {getFullDateDayName(grade.date)} - {grade.time} {getLocalizedString("hrs")}
                                </Typography>
                                {
                                    Boolean(grade.content) &&
                                    <TextEditor
                                        initialValue={grade.content}
                                        maxHeight={"100%"}
                                        disabled
                                    />
                                }
                            </div>
                        </Container>
                    )
                })
            }
        </>
    )
}

export default GradesHistoryContent;